import { every, filter, get, isFunction, includes, lowerCase, merge, orderBy, toLower } from 'lodash'

const _ALL = typeof Symbol === 'function' ? Symbol('_ALL') : '_ALL'
const _FILTERS = typeof Symbol === 'function' ? Symbol('_FILTERS') : '_FILTERS'

export class ClientFactory {
  constructor () {
    this[_ALL] = get(require('@/data'), 'clients', [])
    this[_FILTERS] = []
  }
  get all () {
    return this[_ALL]
  }
  get ordered () {
    return orderBy(this[_ALL], client => lowerCase(client.family_name))
  }
  get filtered () {
    return filter(this.ordered, client => {
      return every(this.appliedFilters, (predicate, field) => {
        const value = client[field]
        return isFunction(predicate) ? predicate(value) : includes(toLower(value), toLower(predicate))
      })
    })
  }
  get appliedFilters () {
    return merge(...this[_FILTERS])
  }
  get bankField () {
    return 'banks_filing_sars___detailed_profile'
  }
  get categoryField () {
    return 'category'
  }
  get countryField () {
    return 'country_iso_3'
  }
  // Chainable methods: they must all return `this`
  filterByBank (value) {
    this[_FILTERS].push({ [this.bankField]: value })
    return this
  }
  filterByCategory (value) {
    this[_FILTERS].push({ [this.categoryField]: value })
    return this
  }
  filterByCountry (value) {
    this[_FILTERS].push({ [this.countryField]: value })
    return this
  }
  clearFilterBy (field) {
    this[_FILTERS] = filter(this[_FILTERS], f => !f.hasOwnProperty(field))
    return this
  }
  clearBankFilter () {
    this.clearFilterBy(this.bankField)
    return this
  }
  clearCategoryFilter () {
    this.clearFilterBy(this.categoryField)
    return this
  }
  clearCountryFilter () {
    this.clearFilterBy(this.countryField)
    return this
  }
  static create () {
    return new ClientFactory()
  }
}

export default new ClientFactory()
